import { CurrencyPipe } from '@angular/common';
import { LoyaltyMode } from '@app/core/redux/stores';

export enum MessageTypes {
  POINTSEARNED = 1,
  REWARDREDEEMED = 2,
  REWARDEXPIRED = 3,
  REWARDEARNED = 4,
  OFFERRECEIVED = 5,
  OFFERREDEEMED = 6,
  PAYMENT = 7,
  LOAD = 8,
  ORDERPLACED = 9,
  ORDERPROCESSING = 10,
  ORDERSENTTOPOS = 11,
  ORDERCANCELLED = 12,
  REWARDONUS = 13,
  VIRTUALGIFTCARDPURCHASE = 14,
  OFFEREXPIRED = 15,
  POINTSCREDITED = 16,
}

export enum NormalMessageTypes {
  REWARDEARNED = 1,
}

export enum FilterTypes {
  DEFAULT = 0,
  ALL = 0,
  PAYMENTS = 1,
  REWARDS = 2,
  OFFERS = 3,
  ORDERS = 4
}

export class FilterType {
  constructor(public type: number, public data: any) {}
}

export class MessageSummary {
  constructor() { }
  balance?: number | 0.00 ;
  currentRewards?: number | 0 ;
  lifetimeVisits?: number | 0;
  lifetimeRewardsEarned?: number | 0 ;
  progress?: number | 0 ;
  points?: number;
  lifetimePointsEarned?: number;
}
export class MessageSummaryLoyalty  extends MessageSummary {
  loyaltyMode?: LoyaltyMode;
  isRewardsUnavailable?: boolean;
}
